import React, { useCallback } from 'react';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { PersonalizedSearchModel, PersonalizedSearchPaths } from 'client/data/models/personalized-search';
import {
  getIntervalsForPaymentType,
  PricingHistogram,
} from 'site-modules/shared/components/inventory/usurp-histogram/pricing-histogram';

export const personalizeSearchPricingHistogramDataProvider = WrappedComponent => {
  const ComponentUI = ({ setModelValue, ...restProps }) => {
    const updateQuery = useCallback(
      query => {
        setModelValue(PersonalizedSearchPaths.getInventoryPriceIntervalsQuery(), PersonalizedSearchModel, query);
      },
      [setModelValue]
    );

    return <WrappedComponent {...restProps} onUpdateQuery={updateQuery} />;
  };

  const Component = connectToModel(ComponentUI, {
    intervals: bindToPath(
      PersonalizedSearchPaths.getInventoryPriceIntervals(),
      PersonalizedSearchModel,
      (data, { facetType }) => getIntervalsForPaymentType(data, facetType),
      false
    ),
    queryForByIntervalAggregation: bindToPath(
      PersonalizedSearchPaths.getInventoryData(),
      PersonalizedSearchModel,
      data => data?.attributes?.queryForByIntervalAggregation,
      false
    ),
  });

  Component.displayName = `personalizeSearchPricingHistogramDataProvider(${
    WrappedComponent.name || WrappedComponent.displayName
  })`;
  return Component;
};

export const PersonalizeSearchPricingHistogramDataProvider =
  personalizeSearchPricingHistogramDataProvider(PricingHistogram);
